import React, { FC, useCallback, useEffect } from 'react'
import styles from 'styles/components/template.module.scss'
import text from 'styles/utility/text.module.scss'
import { Spacer } from 'components/Utility'
import { GreyButton, NavButton } from 'components/Button'
import { useDispatch } from 'react-redux'
import { push } from 'connected-react-router'
import { FlexColumn } from 'components/Flex'
import { initCampaigns } from 'reducks/campaign/operations'

const CampaignCompleteTemplate: FC = () => {
  const dispatch = useDispatch()
  const backToCampaignPage = useCallback(() => dispatch(push('/admin/campaign_cms')), [dispatch])
  useEffect(() => {
    dispatch(initCampaigns())
  }, [])
  return (
    <div className={styles.standard}>
      <Spacer size={28} />
      <FlexColumn alignItems={'center'}>
        <img src={'/icon/done/cms.svg'} alt={'キャンペーンの作成が完了しました'} />
        <Spacer size={16} />
        <h2 className={`${text.font_xxxlarge} ${text.align_center}`}>
          キャンペーンの作成が
          <br />
          完了しました
        </h2>
      </FlexColumn>
      <Spacer size={48} />
      <GreyButton label={'キャンペーン画面へ戻る'} onClick={backToCampaignPage} size={'medium'} type={'outlined'} />
      <Spacer size={24} />
      <NavButton label={'トップページに戻る'} iconPath={'/icon/grey/home.svg'} url={'/admin/shops'} />
      <Spacer size={72} />
    </div>
  )
}

export default CampaignCompleteTemplate
